import { render } from "./DirectoryTreeItem.vue?vue&type=template&id=b4f5e6d8&scoped=true"
import script from "./DirectoryTreeItem.vue?vue&type=script&lang=js"
export * from "./DirectoryTreeItem.vue?vue&type=script&lang=js"

import "./DirectoryTreeItem.vue?vue&type=style&index=0&id=b4f5e6d8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f5e6d8"]])

export default __exports__